<script setup lang="ts">
import { BsButton } from '@afo/bsf-core'
import type { IProps, IEmits } from './StepController.types'
defineProps<IProps>()
defineEmits<IEmits>()
</script>

<template>
  <div class="stepController">
    <BsButton
      :class="previousButtonConfig.disabled && `stepController__button--${previousButtonConfig.variant}--disabled`"
      :disabled="previousButtonConfig.disabled"
      @click="$emit('previousStep')"
    >
      {{ previousButtonConfig.text || $t('step.back') }}
    </BsButton>

    <BsButton
      :class="nextButtonConfig.disabled && `stepController__button--${nextButtonConfig.variant}--disabled`"
      :disabled="nextButtonConfig.disabled"
      @click="$emit('nextStep')"
    >
      {{ nextButtonConfig.text || $t('step.next') }}
    </BsButton>
  </div>
</template>

<style lang="scss" scoped>
.stepController {
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;
  gap: 1.6rem;
  width: 100%;

  :deep(.bs-button) {
    width: 100%;
    border-radius: 999px;
    @include body-3;
  }

  @include atXS {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0;

    :deep(.bs-button) {
      width: 16rem;
    }
  }

  &__button--standard--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__button--lightGrey--disabled {
    color: $text-300;
    background-color: $gray-200;
    pointer-events: none;
  }
}
</style>
